<template>
    <nav class="main-menu">
        <div class="wrap-items">
            <div class="container">
                <div class="wrapping-level-0" v-if="showCol1">
                    <ul class="wrap-level-0">
                        <li v-for="(item, index) in items" @click="selectMenu(item, $event)"
                            :class="{
                                active : item.child === active_menu && breakpointUpLg, 
                                'has-child': item.child.length !== 0
                            }">
                            <a :href="item.child.length === 0 ? item.url : '#'"
                               :target="item.child.length === 0 ? item.target : ''"
                                v-html="item.title" ></a>
                        </li>
                    </ul>
                </div>
                <div class="btn-back" v-if="!breakpointUpLg && step >= 2" @click.prevent="goBackLevel()">
                    <span class="icon-arrow-left"></span>
                    <a href="" @click.prevent>
                        <slot name="back"></slot>
                    </a>
                </div>
                <div class="wrapping-level-1" v-if="showCol2">
                    <ul class="wrap-level-1">
                        <li v-for="(item, index) in active_menu"
                            :class="{active : item.child === active_sub_menu && breakpointUpLg, 'has-child': item.child.length !== 0}">
                            <a href=""
                               target="item.target"
                               @click.prevent="selectSubMenu(item)"
                               v-if="item.child.length !== 0"
                               v-html="item.title"></a>
                            <a :href="item.url"
                               :target="item.target"
                               v-else
                               v-html="item.title"></a>
                        </li>
                        <p class="no-entry" v-if="active_menu.length === 0">
                            <slot name="no-entry"></slot>
                        </p>
                    </ul>
                </div>

                <div class="wrapping-level-2" v-if="showCol3">
                    <ul class="wrap-level-2">
                        <li v-for="(item, index) in active_sub_menu">
                            <a :href="item.url" v-html="item.title" :class="{active: item.active}" :target="item.target"
                               v-if="item.child.length === 0"></a>
                            <p v-else v-html="item.title" class="sub_category_header"></p>


                            <div v-if="item.child.length !== 0" class="sub_category">
                                <div v-for="(sub_item, index) in item.child">
                                    <a :href="sub_item.url" v-html="sub_item.title" :class="{active: sub_item.active}" :target="sub_item.target"></a>
                                </div>
                            </div>
                        </li>
                        <p class="no-entry" v-if="active_sub_menu.length === 0">
                            <slot name="no-entry"></slot>
                        </p>
                    </ul>
                </div>
            </div>
        </div>
        <div class="wrap-footer">
            <div class="container">
                <div class="wrap">
                    <slot name="desktop" v-if="breakpointUpLg"></slot>
                    <slot name="mobile" v-else></slot>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import $ from "jquery";
    import {find, debounce} from "lodash"

    require("jquery-mousewheel");
    require("malihu-custom-scrollbar-plugin");

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                active_menu: {},
                active_sub_menu: {},
                step: 1
            };
        },
        watch: {
            menuOpen(newVal) {
                if (newVal) {
                    this.checkActiveMenus()
                }
            }

        },
        computed: {
            breakpointUpLg() {
                return this.$root.breakpointUpLg;
            },
            showCol1() {
                return this.breakpointUpLg || this.step === 1
            },
            showCol2() {
                return this.breakpointUpLg || this.step === 2
            },
            showCol3() {
                return this.breakpointUpLg || this.step === 3
            },
            menuOpen() {
                return this.$root.menuOpen
            }
        },
        methods: {
            selectMenu(item, event) {
                console.log(event);
                if (item.child.length > 0) {
                    event.preventDefault();
                    let $item = $(".wrap-level-1")
                    let $item2 = $(".wrap-level-2")
                    $item.mCustomScrollbar("destroy");
                    $item2.mCustomScrollbar("destroy");
                    this.active_sub_menu = {}
                    this.active_menu = item.child
                    this.step = 2
                    this.$nextTick(function () {
                        let $item = $(".wrap-level-1")
                        this.initCustomSCrollBar($item)
                        $(".wrap-level-1 .mCSB_container").addClass("show")
                    })
                }
            },
            selectSubMenu(item) {
                this.step = 3
                let $item = $(".wrap-level-2")
                $item.mCustomScrollbar("destroy");
                this.active_sub_menu = item.child
                this.$nextTick(function () {
                    let $item = $(".wrap-level-2")
                    this.initCustomSCrollBar($item)
                    $(".wrap-level-2 .mCSB_container").addClass("show")
                })
            },
            initCustomSCrollBar($item) {
                $item.mCustomScrollbar({
                    theme: "taaf",
                    mouseWheel: true,
                    scrollInertia: 300,
                    moveDragger: true
                });
            },
            goBackLevel() {
                if (this.step === 2) {
                    this.goBackLevel0()
                } else {
                    this.goBackLevel1()
                }
            },
            goBackLevel0() {
                let $item = $(".wrap-level-1")
                $item.mCustomScrollbar("destroy");
                this.step = this.step - 1
                this.$nextTick(function () {
                    let $item = $(".wrap-level-0")

                    this.initCustomSCrollBar($item)
                    $(".wrap-level-0 .mCSB_container").addClass("show")
                })

            },
            goBackLevel1() {
                let $item = $(".wrap-level-2")
                $item.mCustomScrollbar("destroy");
                this.step = this.step - 1
                this.$nextTick(function () {
                    let $item = $(".wrap-level-1")

                    this.initCustomSCrollBar($item)
                    $(".wrap-level-1 .mCSB_container").addClass("show")
                })
            },
            checkActiveMenus: debounce(function () {
                let mainItem = find(this.items, function (o) {
                    return o.active === true;
                });
                if (mainItem) {
                    this.selectMenu(mainItem)

                        let subItem = find(this.active_menu, function (o) {
                            return o.active === true;
                        });
                        if (subItem) {
                            this.selectSubMenu(subItem)
                        }
                }
                return false


            }, 100)
        },
        mounted() {
            let $item = $(".wrap-level-0")
            this.initCustomSCrollBar($item)
            $(".wrap-level-0 .mCSB_container").addClass("show")


        },
        destroyed() {
        }
    };
</script>
